import { useState, useEffect, useContext, createContext } from "react";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
  onIdTokenChanged,
  sendPasswordResetEmail,
} from "firebase/auth";
import firebase from "@/utils/Firebase";
// import { createUser } from "@/utils/db";
import cookies from "js-cookie";
import { useRouter } from "next/router";
const authContext = createContext();

export function AuthProvider({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}
export const useAuth = () => {
  return useContext(authContext);
};
function useProvideAuth() {
  const { push,asPath } = useRouter();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth(firebase);
  const handleUser = async (rawUser) => {
    if (rawUser) {
      const user = await formatUser(rawUser);
      const { token, ...userWithoutToken } = user;
      // createUser(user.uid, userWithoutToken);
      setUser(user);
      cookies.set("token", user.token, {
        expires: 1,
        secure: true,
        sameSite: "strict",
      });
      setLoading(false);
      return user;
    } else {
      setUser(false);
      cookies.remove("token");
      setLoading(false);
      return false;
    }
  };
  const signinWithEmail = (email, password) => {
    setLoading(true);
    return signInWithEmailAndPassword(auth, email, password).then(
      (response) => {
        handleUser(response.user);
      }
    );
  };
  const signupWithEmail = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password).then(
      (response) => {
        handleUser(response.user);
        return response.user;
      }
    );
  };
  const signinWithGoogle = () => {
    setLoading(true);
    return signInWithPopup(auth, new GoogleAuthProvider()).then((response) => {
      handleUser(response.user);
    });
  };
  const PasswordReset = (email) => {
    return sendPasswordResetEmail(auth, email).then(() => {
      return true;
    });
  };
  const signOutfunc = () => {
    const pastRouter = asPath;
    push(`/SignIn?url=${pastRouter}`);
    return signOut(auth).then(() => handleUser());
  };

  useEffect(() => {
    const unsubscribe = onIdTokenChanged(auth, handleUser);
    return () => unsubscribe();
  }, []);

  return {
    user,
    loading,
    signinWithEmail,
    PasswordReset,
    signinWithGoogle,
    signupWithEmail,
    signOutfunc,
  };
}
const formatUser = async (user) => {
  const token = await user.getIdToken();
  return {
    uid: user.uid,
    email: user.email,
    name: user.displayName,
    token,
    admin: false,
    // provider: null || user.providerData[0].providerId,
  };
};
